import React from 'react';
import { Card, CardContent, Typography, Box, Divider } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import { NoticiaList } from '../../../../../typesSite/noticia/Noticia';
import { gerarUrlCapa } from '../create/gerarUrlCapa';
import { useNavigate } from 'react-router-dom';
import configSiteUrls from '../../../configs/configSiteUrls';

interface NoticiaCardProps {
  noticia: NoticiaList;
}

export default function NoticiaPublicCardForm({ noticia }: NoticiaCardProps) {
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    // Salva posição do scroll (se quiser implementar esse comportamento)
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const now = new Date().toISOString();
    localStorage.setItem('scrollPublicacao', JSON.stringify({ posicao: scrollPosition, data: now, idnoticia: noticia.id }));

    navigate(`${configSiteUrls.SITE_NOTICIA_PUBLIC_VIEW_LK}${noticia.id}`);
  };

  if (!noticia) {
    return <div>Erro: dados não carregados!</div>;
  }

  return (
    <Card key={noticia.id} id={noticia.id} sx={{ width: '100%', mt: 1 }}>
      <a href="#" onClick={handleClick} style={{ textDecoration: 'none', color: 'inherit' }}>
        <CardContent sx={{ p: 1 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' }, // coluna no celular, linha no desktop
              borderBottom: '1px solid #eee',
              pb: 1,
              mb: 1,
              gap: 2
            }}
          >
            {/* Imagem */}
            {noticia.imagem && (
              <Box
                sx={{
                  flexShrink: 0, // impede que a imagem "estique" junto com o texto
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: { xs: '100%', sm: '200px', md: '250px' } // largura fixa nos breakpoints
                }}
              >
                <Box
                  component="img"
                  src={gerarUrlCapa(noticia.imagem, 'NOTICIA')}
                  alt={noticia.imagem}
                  sx={{
                    width: '100%',
                    height: { xs: '200px', sm: '150px', md: '180px' }, // altura fixa para padronizar
                    //objectFit: 'cover', 
                    borderRadius: 2,
                    objectFit: 'contain' // Ajusta para não cortar ou distorcer
                  }}
                />
              </Box>
            )}

            {/* Texto */}
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
              {/* Título */}
              <Typography
                color="primary"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: '15px', sm: '16px', md: '17px' },
                  lineHeight: '22px',
                  mb: 0.5
                }}
              >
                <CircleIcon sx={{ fontSize: 10, mr: 1, color: 'primary.main' }} />
                {noticia.titulo}
              </Typography>

              {/* Autor (opcional) */}
              {/* <Typography color="secondary" variant="caption" component="div">
          Por: {noticia?.usuario?.nome}
        </Typography> */}

              {/* Data */}
              <Typography variant="caption" color="secondary" sx={{ textAlign: 'right', mt: 1 }}>
                {noticia?.dataHoraCriacao ? new Date(noticia?.dataHoraCriacao).toLocaleDateString() : ''}
              </Typography>

              {/* Resumo */}
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: 'justify' }}>
                {noticia?.resumo}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </a>
    </Card>
  );
}
